<template>
  <ul class="contacts-list">
    <li
      v-for="(item, index) in value"
      :key="`contacts-list__item${index}`"
      class="contacts-list__item"
    >
      <article class="contacts-list__content">
        <v-btn
          v-if="index!=0"
          text
          icon
          color="red"
          class="contacts-list__remove"
          @click="deleteItem(item)"
        >
          <v-icon>delete</v-icon>
        </v-btn>
        <p class="contacts-list__text">
          <strong>Nome: </strong>
          <span>{{ _readProperty(item, 'nome') }}</span>
        </p>
        <p class="contacts-list__text">
          <strong>CPF: </strong>
          <span>{{ _readProperty(item, 'cpf') }}</span>
        </p>
        <p class="contacts-list__text">
          <strong>Celular: </strong>
          <span>{{ _readProperty(item, 'celular') }}</span>
        </p>
        <p class="contacts-list__text">
          <strong>Telefone: </strong>
          <span>{{ _readProperty(item, 'telefone') }}</span>
        </p>
        <p class="contacts-list__text">
          <strong>Email: </strong>
          <span>{{ _readProperty(item, 'email') }}</span>
        </p>
      </article>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ContactList',

  props: {
    value: {
      type: Array,
      default: ()=>([]),
    },
  },

  methods: {
    deleteItem(item) {
      const indexOf = this.value.indexOf(item)
      if (indexOf > -1) {
        this.value.splice(indexOf, 1)
        this.$emit('input', this.value);
      }
    },


    _readProperty(item, propertyChain) {
      return _.get(item, propertyChain, '-') || '-'
    },
  }
}
</script>

<style lang="scss" scoped>
.contacts-list{
  padding: 0px;
  margin: 10px 0px 0px 0px;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  &__item{
    margin-bottom: 20px;
    margin-right: 20px;
  }

  &__content{
    background: #f5f5f5;
    border: solid 1px #eee;
    padding: 10px;
    max-width: 250px;
    width: 250px;
    border-radius: 4px;
  }

  &__remove{
    float: right;
  }

  &__text{
    margin-bottom: 10px;
  }
}
</style>
